import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

    ;

import axios from "axios";
import useTableScroll from "../useTableScroll";
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

const CargarDesdeEjercicio = props => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem("jwtToken");

    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const idorganizacion = JSON.parse(localStorage.getItem('idorganizacion'));

    const btnCancela = useRef();
    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);
    const [operacion, setOperacion] = useState()
    const [select, setSelect] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [activo, setActivo] = useState(true);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'CÓDIGO', textAlign: 'center' },
        { label: 'DESCRIPCIÓN', textAlign: 'center' },
        { label: 'AÑO', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idefiscal.includes(target.value)
                            || x.descriptor.toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }



    const seleccionarEjercicioFiscal = () => {

        setActivate(true);

        let campos = '*';
        let nomtab = 'efiscal';
        let orden = 'anio desc';

        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                setActivate(false);
                var clase = []
                for (let i = 0; i < response.data.length; i++) {
                    clase.push({
                        idefiscal: response.data[i].idefiscal,
                        descriptor: response.data[i].descriptor,
                        anio: response.data[i].anio,
                        observaciones: response.data[i].observaciones,
                        statusorg: response.data[i].statusorg,
                        statuspresup: response.data[i].statuspresup,
                        statuspuc: response.data[i].statuspuc,
                        statuscat: response.data[i].statuscat,
                        idorganizacion: response.data[i].idorganizacion,
                        activo: response.data[i].activo,
                    })
                }
                setRecords(clase)

            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
            setActivate(false);

        })
    }

    const blanquear = () => {
        setItemSelect("");
        setActivate(false);
        setRecords([]);
        setActivo(true);
        setOperacion(0)
        setFilterFn({ fn: items => { return items; } });
    }

    const cancelar = () => {
        blanquear();
        props.setShow(false);
    }

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        blanquear();
        props.setShow(false);
    }

    const seleccionarEfiscal = (index) => (event) => {

        let mensaje = '';
        if (parseInt(values[0].idefiscal) === idefiscal) {
            mensaje = 'No puede seleccionar el mismo ejercicio fiscal';
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
            return;
        }

        if (operacion === 1) {

            setMensajesino({ mostrar: true, titulo: 'Notificación.', texto: 'Al cargar el catalogo de cuenta desde ejercicio fiscal se borrara todo el catalogo de cuentas anterior está seguro que desea seguir?', icono: 'informacion' })

        } else if (operacion === 2) {

            setMensajesino({ mostrar: true, titulo: 'Notificación.', texto: 'Al cargar saldos iniciales desde ejercicio fiscal se borrara todo el catalogo de cuentas anterior está seguro que desea seguir?', icono: 'informacion' })

        } else if (operacion === 3) {

            setMensajesino({ mostrar: true, titulo: 'Notificación.', texto: 'Al cargar Vinculaciones desde ejercicio fiscal se borraran todas las vinculaciones anteriores está seguro que desea seguir?', icono: 'informacion' })

        } else if (operacion === 18) {
            setMensaje({ mostrar: true, titulo: 'Notificación.', texto: 'Desea seguir?', icono: 'informacion' })

        }



    };

    /*  const crearCuentasContables = (data) => {
 
         setActivate(true);
 
         for (let i = 0; i < data.length; i++) {
 
             let endpoint = `${op.conexion}/api/contabilidadfis/cuentascontacrear`;
 
             let haber = 0;
             let debe = 0;
 
             if (parseInt(data[i].naturaleza) === 1) {
 
                 console.log('naturaleza = 1');
 
                 if (parseFloat(data[i].haber) - parseFloat(data[i].debe) > 0) {
 
                     console.log('haber - debe > 0');
                     haber = parseFloat(data[i].haber) - parseFloat(data[i].debe);
                     debe = 0;
 
                 } else {
 
                     haber = 0;
                     debe = parseFloat(data[i].debe) - parseFloat(data[i].haber);
 
                 }
 
 
             } else {
 
                 console.log('naturaleza != 0');
 
                 if (parseFloat(data[i].debe) - parseFloat(data[i].haber) > 0) {
 
                     console.log('haber - debe > 0');
                     debe = parseFloat(data[i].debe) - parseFloat(data[i].haber);
                     haber = 0;
 
                 } else {
 
                     debe = 0;
                     haber = parseFloat(data[i].haber) - parseFloat(data[i].debe);
 
                 }
 
 
             }
 
             let body = {
                 m_cCta: data[i].codigocuenta,
                 m_nMontodebe: debe,
                 m_nMontohaber: haber,
                 m_nEfiscal: idefiscal,
                 m_nIdCta: 0,
                 m_dFecmov: efiscalanio + '-01-01'
             }
 
             console.log(body)
 
             axios.post(endpoint, body, {
                 headers: {
           "x-access-token": `${token}`,
           'Content-Type': 'application/json'
 
         }
             }).then(function (response) {
 
                 if (response.status == 200) {
 
 
 
                 }
                 setActivate(false);
             }).catch(function (error) {
 
                 setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });
 
                 setActivate(false);
 
             })
         }
 
     } */

    const selectNaturaleza = (id) => {

        let endpoint = `${op.conexion}/api/contabilidadfis/selectnaturaleza?idefiscal=${id}&efiscalanio=${efiscalanio}`;

        setActivate(true);


        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                /*  crearCuentasContables(response.data) */
                setMensaje({ mostrar: true, titulo: 'Notificación.', texto: 'Operación exitosa', icono: 'informacion' })

                console.log('exitoso')

            }
            setActivate(false);
        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })


    }


    const seleccionarFila = (index) => (event) => {
        setItemSelect(index);
        setActivo(false);
        setSelect(parseInt(idefiscal));
        var idefiscal = recordsAfterPagingAndSorting()[index].idefiscal;
        /*   var descriptor = recordsAfterPagingAndSorting()[index].descriptor;
          var anio = recordsAfterPagingAndSorting()[index].anio;
          var observaciones = recordsAfterPagingAndSorting()[index].observaciones;
          var statusorg = recordsAfterPagingAndSorting()[index].statusorg;
          var statuspresup = recordsAfterPagingAndSorting()[index].statuspresup;
          var statuspuc = recordsAfterPagingAndSorting()[index].statuspuc;
          var statuscat = recordsAfterPagingAndSorting()[index].statuscat;
          var idorganizacion = recordsAfterPagingAndSorting()[index].idorganizacion;
          var activo = recordsAfterPagingAndSorting()[index].activo; */

        var datos = [];
        datos.push({
            idefiscal,

        })
        setValues(datos);

    };

    const cargarEjercicio = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })

        let endpoint = `${op.conexion}/api/contabilidadfis/cargardesdeejercicio`;

        setActivate(true);

        let body = {
            idefiscal: values[0].idefiscal,
            efiscal: idefiscal
        };

        console.log(body)


        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {


                if (operacion === 1) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'El plan de cuenta fúe cargado', icono: 'exito' })

                } else if (operacion === 3) {
                    /*     setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'El plan de cuenta fúe cargado', icono: 'exito' }) */
                    selectNaturaleza(values[0].idefiscal)

                }



            }
            setActivate(false);
        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })


    }

    const cargarVinculacion = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })

        let endpoint = `${op.conexion}/api/contabilidadfis/seleccionarpuc?idefiscal=${values[0].idefiscal}`;
        let body;
        setActivate(true);


        axios.post(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Vinculación Cargada', icono: 'exito' })

            }
            setActivate(false);
        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })


    }

    const datosRes = () => {
        let campos = '*';
        let nomtab = 'efiscal';
        let nomid = 'idefiscal';
        let nomid2 = 'idorganizacion';
        let id2 = idorganizacion;

        let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&id=${values[0].idefiscal}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${id2}`;
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status === 200) {
                console.log(response.data[0])
                localStorage.setItem('efiscaldes', response.data[0].descriptor);
                localStorage.setItem('efiscalanio', response.data[0].anio);
                localStorage.setItem('idefiscal', values[0].idefiscal);
                localStorage.setItem('statuscat', response.data[0].statuscat);
                localStorage.setItem('statusorg', response.data[0].statusorg);
                localStorage.setItem('statuspresup', response.data[0].statuspresup);
                localStorage.setItem('statuspuc', response.data[0].statuspuc);
                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Cambio realizado con exito', icono: 'exito' })










            }
            setActivate(false);
        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        })
    };

    const handleCloseSi = () => {

        setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });

        if (operacion === 3) {
            cargarVinculacion()
        } else if (operacion === 18) {
            datosRes()
        } else if (operacion === 1 || operacion === 3) {
            cargarEjercicio()
        }

    }


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarEjercicioFiscal();
                setSelect(parseInt(idefiscal));
                setOperacion(parseInt(props.operacion))
            }}
        >
            <Modal.Header className='azulGradiant'>
                <div className="fw-bold text-light"><h3>Cargar desde Ejercicio Fiscal.</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => mensaje.titulo === 'Exito.' ? cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <MensajeSiNo
                    mensaje={mensajesino}
                    onHideNo={() => {
                        setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
                    }}
                    onHideSi={handleCloseSi}
                />
                <div className="col-md-12" style={{ marginBottom: "10px" }}>
                    <div className="row justify-content-start">
                          <div className="input-group col-md-3 input-group-sm mb-3">
                            <input type='text'
                                onChange={handleSearch} className="form-control search-input rounded-pill" />
                        </div>
                        <div className='col-md-9'></div>
                    </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.idefiscal} style={{ padding: "0", cursor: 'pointer', backgroundColor: select === parseInt(item.idefiscal) ? "lightskyblue" : itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td className='py-2 text-center'>{item.idefiscal}</td>
                                        <td className='py-2 text-start'>{item.descriptor}</td>
                                        <td className='py-2 text-center'>{item.anio}</td>

                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={seleccionarEfiscal()}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CargarDesdeEjercicio;